// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconDebug } from '@ni/nimble-components/dist/esm/icons/debug';
import { wrap } from '../utilities/react-wrapper';

export { type IconDebug };
export const NimbleIconDebug = wrap(IconDebug);